import { render } from "./Stories.vue?vue&type=template&id=c3703d3a"
import script from "./Stories.vue?vue&type=script&lang=js"
export * from "./Stories.vue?vue&type=script&lang=js"

import exportComponent from "/root/projects/website/vue-notus-main/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__